import type { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { ConfirmProvider } from './ui/confirm-provider';

export function ConfirmationHost({ children }: { children: ReactNode }): JSX.Element {
  const location = useLocation();
  return <ConfirmProvider resetKey={location.key}>{children}</ConfirmProvider>;
}
